import { Card, Col, List, Row, TextField, useTable } from '@pankod/refine-antd';
import { HttpError } from '@pankod/refine-core';
import { DashbaordTypes } from 'interfaces';

const DashboardList = () => {
  const { tableQueryResult } = useTable<
    DashbaordTypes,
    HttpError,
    DashbaordTypes
  >({
    resource: 'dashboard',
    metaData: {
      fields: ['name', 'value'],
    },
  });
  const { data } = tableQueryResult;
  const record = data?.data;

  const DashboarData = record?.map((val, index) => (
    <Col xs={8}>
      <Card>
        <div className='dashboard-card'>
          <TextField strong value={val.name} style={{ fontSize: '25px' }} />
          <TextField value={val.value} style={{ fontSize: '20px' }} />
        </div>
      </Card>
    </Col>
  ));
  return (
    <List>
      <Row gutter={[30, 0]}>{DashboarData}</Row>
    </List>
  );
};

export default DashboardList;
